export default {
  common: {
    all: '全部',
    confirm: '確認',
    cancel: '取消',
    save: '保存',
    delete: '刪除',
    edit: '編輯',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    logout: '退出登錄',
    login: '登錄',
    username: '用戶名',
    password: '密碼',
    phone: '電話',
    email: '郵箱',
    address: '地址',
    status: '狀態',
    action: '操作',
    detail: '詳情',
    export: '導出',
    import: '導入',
    upload: '上傳',
    download: '下載',
    view: '查看',
    add: '添加',
    close: '關閉',
    language: '語言',
    loading: '加載中...',
    noData: '暫無數據',
    success: '操作成功',
    error: '操作失敗',
    warning: '警告',
    info: '提示',
    total: '共',
    items: '條',
    today: '今日',
    days: '天',
    amount: '金額',
    createTime: '創建時間',
    startDate: '開始日期',
    endDate: '結束日期',
    to: '至',
    distribution: '分布',
    batchDelete: '批量刪除'
  },
  nav: {
    dashboard: '儀表盤',
    appointment: '預約管理',
    order: '訂單管理',
    customer: '客戶管理',
    store: '門店管理',
    staff: '員工管理',
    material: '材料管理',
    finance: '財務管理',
    statistics: '統計報表',
    referrerStatistics: '介紹人統計',
    priceTemplate: '報價單模板',
    notification: '通知中心',
    profile: '個人中心',
    adminManagement: '管理員管理'
  },
  login: {
    title: '老屋醫生',
    subtitle: '維修服務管理系統',
    roleAdmin: '管理員',
    roleAdministrative: '行政',
    username: '請輸入用戶名',
    password: '請輸入密碼',
    rememberMe: '記住我',
    loginButton: '登錄',
    loggingIn: '登錄中...',
    loginSuccess: '登錄成功',
    loginFailed: '登錄失敗',
    usernameRequired: '請輸入用戶名',
    passwordRequired: '請輸入密碼',
    invalidCredentials: '用戶名或密碼錯誤',
    accountDisabled: '賬號已被禁用',
    networkError: '網絡錯誤，請稍後重試',
    languagePreference: '語言偏好'
  },
  appointment: {
    title: '預約',
    list: '預約列表',
    detail: '預約詳情',
    create: '創建預約',
    email: '郵箱',
    name: '姓名',
    phone: '電話',
    address: '地址',
    lineId: 'Line ID',
    isUrgent: '是否緊急',
    urgent: '緊急',
    repairType: '修繕類型',
    description: '補充說明',
    images: '圖片集',
    otherRequirements: '其他需求說明',
    howKnow: '如何得知老屋醫生',
    referrerPhone: '介紹人手機號',
    referrerStore: '介紹店家',
    joinedMember: '是否加入老屋醫生',
    normal: '普通',
    yes: '是',
    no: '否',
    generateWorkOrder: '生成報修單',
    assignStore: '指派門店',
    // 統計
    totalCount: '總預約數',
    pendingCount: '待處理',
    urgentCount: '緊急預約',
    // 搜索
    region: '地區',
    regionPlaceholder: '請輸入地區',
    statusPlaceholder: '請選擇',
    // 狀態
    pending: '待處理',
    converted: '已轉換',
    cancelled: '已取消',
    pending_review: '待審核',
    pending_technician: '待分配師傅',
    quoted: '已報價',
    material_preparing: '備料中',
    pending_construction: '待施工',
    constructing: '施工中',
    pending_acceptance: '待驗收',
    acceptance: '驗收中',
    completed: '已完成',
    closed: '已結案',
    // 操作
    cancel: '取消',
    cancelConfirm: '確定要取消此預約嗎？',
    cancelSuccess: '取消成功',
    cancelFailed: '取消失敗',
    deleteConfirm: '確定要刪除此預約嗎？此操作不可恢復！',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    fetchListFailed: '獲取預約列表失敗',
    fetchDetailFailed: '獲取預約詳情失敗',
    // 詳情
    reservationId: '預約ID',
    sourceChannel: '來源渠道',
    recommenderName: '推薦人姓名',
    updateTime: '更新時間',
    caseNo: '案件編號',
    currentStage: '當前階段',
    storeName: '門店名稱',
    surveyorName: '勘查師傅',
    constructorName: '施工師傅',
    surveyTime: '勘查時間',
    customerDemand: '客戶需求',
    otherDemand: '其他需求',
    // 階段信息
    orderDemand: '訂單需求',
    quotationStage: '報價信息',
    materialStage: '備料信息',
    constructionStage: '施工信息',
    acceptanceStage: '驗收信息',
    // 報價
    quotedAmount: '報價金額',
    quotationDesc: '報價說明',
    totalApprovedAmount: '已批准總金額',
    quotationTime: '報價時間',
    quoterName: '報價人',
    approverName: '審批人',
    approvalTime: '審批時間',
    // 備料
    materialName: '材料名稱',
    materialPrice: '材料價格',
    prepareTime: '備料時間',
    preparerName: '備料人',
    // 施工
    constructionDate: '施工日期',
    beforeRecords: '施工前',
    duringRecords: '施工中',
    afterRecords: '施工後',
    recordTime: '記錄時間',
    recorderName: '記錄人',
    // 驗收
    completionDate: '完成日期',
    chargeAmount: '收費金額',
    acceptanceDate: '驗收日期',
    paymentMethod: '支付方式',
    collectionAmount: '收款金額',
    acceptorName: '驗收人',
    customerConfirm: '客戶確認',
    customerSignature: '客戶簽名',
    remark: '備註',
    noData: '暫無數據',
    adminRemark: '管理員備註',
    noRemark: '暫無備註',
    remarkPlaceholder: '請輸入備註內容...',
    remarkSaveSuccess: '備註保存成功',
    remarkSaveFailed: '備註保存失敗',
    // 导出和打印
    allStatus: '全部狀態',
    allUrgent: '全部',
    exportExcel: '導出Excel',
    exportingExcel: '正在導出Excel，請稍候...',
    noDataToExport: '沒有數據可導出',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    exportTip: '如果不選擇任何條件，將導出所有數據（包括所有分頁）',
    print: '打印',
    order: '訂單',
    basicInfo: '基本信息',
    orderDetail: '訂單詳情',
    generatingPDF: '正在生成PDF，請稍候...',
    printSuccess: '打印成功',
    printFailed: '打印失敗'
  },
  customer: {
    title: '客戶管理',
    list: '客戶列表',
    detail: '客戶詳情',
    // 統計
    totalCount: '總客戶數',
    activeCount: '啟用客戶',
    inactiveCount: '禁用客戶',
    todayNewCount: '今日新增',
    // 基本信息
    customerId: '客戶ID',
    username: '用戶名',
    realName: '姓名',
    phone: '電話',
    email: '郵箱',
    lineId: 'LINE ID',
    address: '地址',
    regionText: '區域',
    orderCount: '訂單數',
    status: '狀態',
    enabled: '啟用',
    disabled: '禁用',
    createTime: '創建時間',
    // 訂單統計
    orderStats: '訂單統計',
    totalOrderCount: '總訂單數',
    totalAmount: '總消費金額',
    pendingCount: '待分配',
    preparingCount: '備料中',
    constructingCount: '施工中',
    acceptanceCount: '驗收中',
    completedCount: '已完成',
    cancelledCount: '已取消',
    // 評價統計
    reviewStats: '評價統計',
    totalReviewCount: '評價總數',
    avgRating: '平均評分',
    orderId: '訂單ID',
    rating: '評分',
    reviewContent: '評價內容',
    reviewerName: '評價人',
    reviewerPhone: '評價人電話',
    reviewTime: '評價時間',
    noReviews: '暫無評價',
    // 操作
    view: '查看',
    edit: '編輯',
    enable: '啟用',
    disable: '冷宮',
    delete: '刪除',
    // 表單
    editCustomer: '編輯客戶',
    pleaseEnterName: '請輸入客戶姓名',
    pleaseEnterPhone: '請輸入聯繫電話',
    pleaseEnterEmail: '請輸入郵箱地址',
    pleaseEnterCorrectEmail: '請輸入正確的郵箱地址',
    phoneFormatError: '電話號碼必須為10位數字',
    // 確認消息
    enableConfirm: '確定要啟用客戶',
    disableConfirm: '確定要將客戶打入冷宮',
    deleteConfirm: '確定要刪除客戶',
    deleteWarning: '此操作不可恢復！',
    // 导出
    allStatus: '全部狀態',
    exportExcel: '導出Excel',
    exportingExcel: '正在導出Excel，請稍候...',
    noDataToExport: '沒有數據可導出',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    exportTip: '如果不選擇任何條件，將導出所有數據（包括所有分頁）',
    // 成功消息
    enableSuccess: '啟用成功',
    disableSuccess: '已打入冷宮',
    deleteSuccess: '刪除成功',
    updateSuccess: '更新成功',
    // 失敗消息
    enableFailed: '啟用失敗',
    disableFailed: '打入冷宮失敗',
    deleteFailed: '刪除失敗',
    updateFailed: '更新失敗',
    fetchListFailed: '獲取客戶列表失敗',
    fetchDetailFailed: '獲取客戶詳情失敗',
    basicInfo: '基本信息',
    remark: '備註',
    noRemark: '暫無備註',
    remarkPlaceholder: '請輸入備註內容...',
    remarkSaveSuccess: '備註保存成功',
    remarkSaveFailed: '備註保存失敗',
    editRemark: '編輯備註'
  },
  workOrder: {
    title: '報修單',
    list: '報修單列表',
    detail: '報修單詳情',
    create: '創建報修單',
    caseNumber: '案件編號',
    inProgress: '進行中報修單',
    customerInfo: '客戶資料',
    customerName: '客戶姓名',
    phone: '聯繫電話',
    surveyPerson: '場勘負責人',
    region: '地區',
    surveyDate: '場勘日期',
    detailAddress: '詳細地址',
    constructionPerson: '施工負責人',
    building: '大樓',
    constructionDate: '施工日期',
    repairType: '修繕類型',
    customerRequirement: '客戶需求',
    surveyResult: '場勘結果',
    chargeAmount: '收費金額',
    customerSignature: '客戶簽名',
    construction: '施工',
    constructionRecord: '施工記錄',
    completionRecord: '完工記錄',
    closure: '結案',
    completionDate: '完工日期',
    paymentDate: '收款日期',
    closureDate: '結案日期',
    engineeringLeader: '工程組長',
    accountingLeader: '會計組長',
    supervisorApproval: '主管審核',
    pending: '待處理',
    completed: '已完成',
    closed: '已結案'
  },
  material: {
    title: '材料備料',
    list: '材料列表',
    name: '材料名稱',
    price: '材料價格',
    quantity: '數量',
    totalPrice: '總價',
    uploadImage: '上傳圖片',
    addMaterial: '添加材料'
  },
  construction: {
    title: '施工管理',
    before: '施工前',
    during: '施工中',
    after: '施工後',
    uploadPhotos: '上傳照片',
    createSubOrder: '創建子訂單',
    subOrder: '子訂單'
  },
  acceptance: {
    title: '驗收',
    paymentMethod: '收款方式',
    cash: '現金',
    transfer: '匯款',
    amount: '金額',
    signature: '客戶簽名',
    complete: '完成驗收'
  },
  finance: {
    title: '財務管理',
    // 统计
    totalRevenue: '總收入',
    todayRevenue: '今日收入',
    monthRevenue: '本月收入',
    completedOrders: '已完成訂單',
    averageOrderValue: '平均訂單金額',
    cancelledOrders: '已取消訂單',
    cancelRate: '取消率',
    todayOrders: '今日訂單',
    monthOrders: '本月訂單',
    // 订单信息
    caseNo: '案件編號',
    customerName: '客戶姓名',
    phone: '電話',
    email: '郵箱',
    lineId: 'LINE ID',
    address: '地址',
    storeName: '門店',
    repairType: '維修類型',
    chargeAmount: '收費金額',
    surveyorName: '勘查師傅',
    constructorName: '施工師傅',
    surveyDate: '勘查日期',
    constructionDate: '施工日期',
    completionDate: '完工日期',
    closeDate: '結案日期',
    customerDemand: '客戶需求',
    surveyResult: '勘查結果',
    // 状态
    closed: '已完成',
    cancelled: '已取消',
    allStatus: '全部狀態',
    allStores: '全部門店',
    // 操作
    orderDetail: '訂單詳情',
    searchKeyword: '搜索案件編號、客戶姓名、電話',
    createStartDate: '創建開始日期',
    createEndDate: '創建結束日期',
    export: '導出報表',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    pleaseSelectDateRange: '請選擇日期範圍',
    // 原有字段
    paymentStatus: '回款狀態',
    paid: '已回款',
    unpaid: '未回款',
    overdue: '逾期',
    overdueWarning: '超期預警',
    paymentRecord: '收款記錄',
    exportExcel: '導出Excel',
    exportingExcel: '正在導出Excel，請稍候...',
    noDataToExport: '沒有數據可導出',
    pleaseEnterCustomerName: '請輸入客戶姓名',
    createTimeRange: '創建時間範圍',
    exportTip: '如果不選擇任何條件，將導出所有數據（包括所有分頁）'
  },
  followUp: {
    title: '售後回訪',
    list: '回訪列表',
    create: '創建回訪',
    callCustomer: '致電客戶',
    feedback: '客戶反饋',
    satisfaction: '滿意度',
    verySatisfied: '非常滿意',
    satisfied: '滿意',
    neutral: '一般',
    dissatisfied: '不滿意'
  },
  store: {
    title: '門店管理',
    list: '門店列表',
    applicationList: '申請列表',
    name: '門店名稱',
    manager: '店長',
    managerPhone: '店長電話',
    address: '門店地址',
    region: '地區',
    detailAddress: '詳細地址',
    phone: '聯繫電話',
    contactPhone: '聯繫電話',
    businessHours: '營業時間',
    status: '狀態',
    active: '營業',
    inactive: '停業',
    operating: '營業中',
    closed: '已停業',
    add: '新增門店',
    edit: '編輯門店',
    detail: '門店詳情',
    delete: '刪除門店',
    deleteConfirm: '確定要刪除門店',
    deleteWarning: '此操作不可恢復！',
    enable: '啟用',
    disable: '停業',
    enableConfirm: '確定要啟用門店',
    disableConfirm: '確定要停業門店',
    createSuccess: '新增成功',
    updateSuccess: '更新成功',
    deleteSuccess: '刪除成功',
    operationFailed: '操作失敗',
    remark: '備註',
    editRemark: '編輯備註',
    remarkPlaceholder: '請輸入備註內容...',
    remarkSaveSuccess: '備註保存成功',
    remarkSaveFailed: '備註保存失敗',
    // 统计
    totalStores: '總門店數',
    activeStores: '營業中',
    inactiveStores: '已停業',
    pendingApplications: '待審核申請',
    // 申请
    applicationId: '申請ID',
    applicant: '申請人',
    applicantName: '申請人',
    applicantPhone: '聯繫電話',
    applicationStatus: '狀態',
    applicationTime: '申請時間',
    applicationDetail: '申請詳情',
    pending: '待審核',
    approved: '已通過',
    rejected: '已拒絕',
    approve: '通過',
    reject: '拒絕',
    auditOpinion: '審核意見',
    auditOpinionPlaceholder: '請輸入審核意見（選填）',
    approveSuccess: '通過成功',
    rejectSuccess: '拒絕成功',
    auditFailed: '審核失敗',
    // 表单
    pleaseEnterStoreName: '請輸入門店名稱',
    pleaseEnterRegion: '請輸入地區',
    pleaseEnterAddress: '請輸入詳細地址',
    pleaseEnterPhone: '請輸入聯繫電話',
    pleaseSelectManager: '請選擇店長',
    businessHoursPlaceholder: '例如：週一至週五 9:00-18:00',
    storeId: '門店ID',
    createTime: '創建時間',
    allStatus: '全部狀態',
    exportExcel: '導出Excel',
    exportingExcel: '正在導出Excel，請稍候...',
    noDataToExport: '沒有數據可導出',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    exportTip: '如果不選擇任何條件，將導出所有數據（包括所有分頁）',
    // 抽成設置
    commissionSettings: '抽成設置',
    commissionTip: '設置不同級別門店的抽成比例，級別越高抽成越低',
    storeLevel: '門店級別',
    levelName: '級別名稱',
    commissionRate: '抽成比例',
    setLevel: '設置級別',
    currentLevel: '當前級別',
    newLevel: '新級別'
  },
  staff: {
    title: '員工管理',
    list: '員工列表',
    name: '姓名',
    username: '用戶名',
    realName: '真實姓名',
    role: '角色',
    phone: '電話',
    email: '郵箱',
    store: '所屬門店',
    status: '狀態',
    password: '密碼',
    technicianLevel: '技師等級',
    lastLoginTime: '最後登錄',
    // 角色
    admin: '管理員',
    administrative: '行政',
    storeManager: '店長',
    technician: '師傅',
    // 状态
    active: '在職',
    inactive: '離職',
    enabled: '啟用',
    disabled: '禁用',
    // 操作
    add: '新增員工',
    edit: '編輯員工',
    detail: '員工詳情',
    delete: '刪除員工',
    view: '查看',
    changeRole: '切換角色',
    resetPassword: '重置密碼',
    enable: '啟用',
    disable: '禁用',
    // 确认消息
    deleteConfirm: '確定要刪除員工',
    deleteWarning: '此操作不可恢復！',
    enableConfirm: '確定要啟用員工',
    disableConfirm: '確定要禁用員工',
    resetPasswordConfirm: '確定要重置密碼嗎？密碼將重置為',
    changeRoleConfirm: '確定要切換員工角色嗎？',
    // 成功消息
    createSuccess: '新增成功',
    updateSuccess: '更新成功',
    deleteSuccess: '刪除成功',
    enableSuccess: '啟用成功',
    disableSuccess: '禁用成功',
    resetPasswordSuccess: '密碼重置成功',
    changeRoleSuccess: '角色切換成功',
    operationFailed: '操作失敗',
    remark: '備註',
    editRemark: '編輯備註',
    remarkPlaceholder: '請輸入備註內容...',
    remarkSaveSuccess: '備註保存成功',
    remarkSaveFailed: '備註保存失敗',
    // 统计
    totalEmployees: '總員工數',
    adminCount: '管理員',
    administrativeCount: '行政人員',
    storeManagerCount: '店長',
    technicianCount: '師傅',
    activeCount: '在職',
    inactiveCount: '離職',
    levelA: 'A級師傅',
    levelB: 'B級師傅',
    levelC: 'C級師傅',
    // 表单
    pleaseEnterUsername: '請輸入用戶名',
    pleaseEnterPassword: '請輸入密碼',
    pleaseEnterRealName: '請輸入真實姓名',
    pleaseEnterPhone: '請輸入電話',
    pleaseEnterEmail: '請輸入郵箱',
    pleaseSelectStore: '請選擇門店',
    pleaseSelectRole: '請選擇角色',
    pleaseSelectLevel: '請選擇技師等級',
    usernameRequired: '請輸入用戶名',
    passwordRequired: '請輸入密碼',
    realNameRequired: '請輸入真實姓名',
    phoneRequired: '請輸入電話',
    roleRequired: '請選擇角色',
    storeRequired: '店長和師傅必須選擇門店',
    levelRequired: '師傅必須選擇技師等級',
    // 详情
    employeeInfo: '員工信息',
    storeInfo: '門店信息',
    region: '地區',
    workStats: '工作統計',
    totalOrders: '總報修單',
    completedOrders: '已完成',
    inProgressOrders: '進行中',
    currentOrders: '當前報修單',
    newPassword: '新密碼',
    // 评价统计
    reviewStats: '評價統計',
    totalReviewCount: '評價總數',
    avgRating: '平均評分',
    reviewDetails: '評價詳情',
    orderId: '訂單ID',
    rating: '評分',
    reviewContent: '評價內容',
    reviewerName: '評價人',
    reviewerPhone: '評價人電話',
    reviewTime: '評價時間',
    noReviews: '暫無評價',
    // 搜索
    searchKeyword: '搜索姓名、手機號、郵箱',
    allRoles: '全部角色',
    allStatus: '全部狀態',
    allStores: '全部門店',
    allLevels: '全部等級',
    // 导出
    exportExcel: '導出Excel',
    exportingExcel: '正在導出Excel，請稍候...',
    noDataToExport: '沒有數據可導出',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    exportTip: '如果不選擇任何條件，將導出所有數據（包括所有分頁）'
  },
  managerApplication: {
    title: '店長申請審核',
    totalApplications: '總申請數',
    pending: '待審核',
    approved: '已通過',
    rejected: '已拒絕',
    applicant: '申請人',
    phone: '聯繫電話',
    email: '郵箱',
    lineId: 'Line ID',
    region: '地區',
    viewDetail: '查看詳情',
    approve: '通過',
    reject: '拒絕',
    applicationDetail: '申請詳情',
    applicationId: '申請ID',
    applicationStatus: '申請狀態',
    reason: '申請理由',
    applicationTime: '申請時間',
    reviewTime: '審核時間',
    reviewer: '審核人',
    assignedStore: '分配門店',
    reviewComment: '審核意見',
    approveTitle: '審核通過',
    rejectTitle: '審核拒絕',
    note: '說明',
    approveNote: '審核通過後將自動為該申請人創建新門店，門店名稱默認為「{name}的門店」，店長可後續自行修改。',
    reviewCommentPlaceholder: '請輸入審核意見（可選）',
    confirmApprove: '確認通過',
    rejectReason: '拒絕理由',
    rejectReasonPlaceholder: '請輸入拒絕理由',
    confirmReject: '確認拒絕',
    fetchDetailFailed: '獲取申請詳情失敗',
    approveSuccess: '審核通過成功，已自動創建門店',
    approveFailed: '審核失敗',
    pleaseEnterRejectReason: '請輸入拒絕理由',
    rejectSuccess: '已拒絕申請'
  },
  notification: {
    title: '通知中心',
    newAppointment: '新預約通知',
    workOrderAssigned: '報修單已指派',
    taskAssigned: '任務已指派',
    paymentOverdue: '回款逾期提醒',
    markAsRead: '標記為已讀',
    markAllAsRead: '全部標記為已讀',
    // WebSocket 通知
    drawerTitle: '預約通知',
    unreadCount: '{count} 條未讀通知',
    markAllRead: '全部標記為已讀',
    noNotifications: '暫無通知',
    viewDetail: '查看詳情',
    urgent: '緊急',
    justNow: '剛剛',
    minutesAgo: '{minutes}分鐘前',
    hoursAgo: '{hours}小時前',
    daysAgo: '{days}天前',
    allMarkedRead: '已全部標記為已讀',
    connectionFailed: '連接失敗',
    websocketConnectionFailed: 'WebSocket連接失敗，請刷新頁面重試'
  },
  dashboard: {
    title: '儀表盤',
    overview: '數據概覽',
    todayAppointment: '今日預約',
    pendingWorkOrder: '待處理報修單',
    inProgressWorkOrder: '進行中報修單',
    completedWorkOrder: '已完成報修單',
    totalRevenue: '總收入',
    monthlyRevenue: '本月收入',
    customerSatisfaction: '客戶滿意度',
    recentAppointments: '最近預約',
    recentWorkOrders: '最近報修單',
    statistics: '統計圖表'
  },
  statistics: {
    title: '統計報表',
    export: '導出報表',
    pleaseSelectDateRange: '請選擇日期範圍',
    selectStore: '選擇門店',
    allStores: '全部門店',
    // 统计指标
    totalOrders: '總訂單數',
    totalRevenue: '總收入',
    totalCustomers: '總客戶數',
    completionRate: '完成率',
    closedOrders: '已結案訂單',
    cancelledOrders: '已取消訂單',
    averageOrderValue: '平均訂單金額',
    todayOrders: '今日訂單',
    todayRevenue: '今日收入',
    monthOrders: '本月訂單',
    monthRevenue: '本月收入',
    // 图表
    orderTrend: '訂單趨勢',
    repairTypeDistribution: '修繕類型分布',
    revenueStats: '收入統計',
    storeRanking: '門店業績排行',
    technicianRanking: '師傅業績排行',
    orderCount: '訂單數',
    revenue: '收入',
    repairType: '修繕類型',
    // 周期
    byDay: '按天',
    byWeek: '按週',
    byMonth: '按月',
    last7Days: '最近7天',
    last14Days: '最近14天',
    last30Days: '最近30天',
    // 图表标题
    orderStatusDistribution: '訂單狀態分布',
    urgentOrders: '緊急訂單',
    // 客户分析
    customerAnalysis: '客戶分析',
    newCustomers: '新客戶',
    returningCustomers: '回頭客',
    returningRate: '回頭率',
    // 地区分布
    regionDistribution: '地區分布',
    percentage: '占比',
    // 修缮类型收入分析
    repairTypeRevenueAnalysis: '修繕類型收入分析',
    revenuePercentage: '收入占比',
    revenueShare: '收入份額',
    averagePrice: '平均單價',
    // 客户来源分析
    customerSourceAnalysis: '客戶來源分析',
    referralOrders: '介紹訂單',
    referralRate: '轉介紹率',
    channelCount: '渠道數量',
    recommenderCount: '介紹人數量',
    channelAnalysis: '來源渠道分析',
    sourceChannel: '來源渠道',
    recommenderAnalysis: '介紹人分析',
    recommenderName: '介紹人姓名',
    recommenderPhone: '介紹人電話',
    recommenderStore: '介紹店家',
    noRecommenderData: '暫無介紹人數據',
    // 订单处理时间分析
    processingTimeAnalysis: '訂單處理時間分析',
    completedOrders: '已完成訂單',
    averageDays: '平均天數',
    minDays: '最短天數',
    maxDays: '最長天數',
    medianDays: '中位數天數',
    timeDistribution: '處理時間分布',
    typeProcessingTime: '各類型處理時間',
    days: '天',
    year: '年',
    // 排行榜
    top3: '前3名',
    top5: '前5名',
    top10: '前10名',
    // 导出
    exportPDF: '導出PDF',
    exportingPDF: '正在生成PDF，請稍候...',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    // 收入统计
    averageMonthlyRevenue: '月均收入',
    highestMonth: '最高月份',
    lowestMonth: '最低月份',
    // 排行榜
    rank: '排名',
    storeName: '門店名稱',
    manager: '店長',
    technicianName: '師傅姓名',
    level: '等級',
    satisfaction: '滿意度',
    displayPercentage: '百分比',
    displayCount: '數量',
    displayBoth: '兩者'
  },
  profile: {
    title: '個人中心',
    basicInfo: '基本信息',
    changePassword: '修改密碼',
    username: '用戶名',
    realName: '真實姓名',
    phone: '手機號碼',
    email: '電子郵箱',
    avatar: '頭像',
    changeAvatar: '更換頭像',
    joinDate: '加入日期',
    lastLogin: '最後登錄',
    lastLoginIp: '最後登錄IP',
    loginCount: '登錄次數',
    oldPassword: '原密碼',
    newPassword: '新密碼',
    confirmPassword: '確認密碼',
    // 角色
    admin: '系統管理員',
    administrative: '行政人員',
    // 提示
    pleaseEnterRealName: '請輸入真實姓名',
    pleaseEnterPhone: '請輸入手機號碼',
    pleaseEnterEmail: '請輸入電子郵箱',
    pleaseEnterOldPassword: '請輸入原密碼',
    pleaseEnterNewPassword: '請輸入新密碼',
    pleaseConfirmPassword: '請確認新密碼',
    phoneFormatError: '手機號碼格式錯誤',
    emailFormatError: '郵箱格式錯誤',
    passwordLengthError: '密碼長度至少6位',
    passwordNotMatch: '兩次密碼輸入不一致',
    avatarFormatError: '頭像只能是JPG或PNG格式',
    avatarSizeError: '頭像大小不能超過2MB',
    // 成功消息
    updateSuccess: '更新成功',
    updateFailed: '更新失敗',
    avatarUploadSuccess: '頭像上傳成功',
    avatarUploadFailed: '頭像上傳失敗',
    passwordChangeSuccess: '密碼修改成功，請重新登錄',
    passwordChangeFailed: '密碼修改失敗'
  },
  administrativeDashboard: {
    title: '行政工作台',
    // 统计卡片
    todayNewReservations: '今日新預約',
    urgentCases: '緊急案件',
    pendingStoreAssignment: '待分配門店',
    pendingFollowUp: '待回訪',
    // 待处理订单
    pendingOrdersTitle: '待處理訂單',
    searchPlaceholder: '搜索客戶姓名/電話',
    viewAll: '查看全部',
    orderNumber: '訂單編號',
    tags: '標籤',
    priority: '優先級',
    urgent: '緊急',
    customerName: '客戶姓名',
    contactPhone: '聯繫電話',
    repairType: '修繕類型',
    region: '地區',
    surveyDate: '勘查日期',
    timeSlot: '時段',
    waitingHours: '等待時長',
    assignedStore: '分配門店',
    view: '查看',
    assignStore: '分配門店',
    // 优先级
    high: '高',
    medium: '中',
    low: '低',
    urgentTag: '急',
    // 订单详情
    orderDetail: '訂單詳情',
    notGenerated: '未生成',
    isUrgent: '是否緊急',
    normal: '正常',
    problemDescription: '問題描述',
    none: '無',
    confirmOrderSuccess: '接單成功',
    // 日历
    weeklyCalendar: '本周訂單日曆',
    viewFullCalendar: '查看完整日曆',
    orders: '單'
  },
  administrativeAppointments: {
    title: '預約管理',
    searchPlaceholder: '搜索姓名/電話/郵箱',
    repairType: '修繕類型',
    search: '搜索',
    reset: '重置',
    // 表格列
    reservationId: '預約ID',
    caseNo: '案例編號',
    urgent: '緊急',
    urgentTag: '急',
    customerName: '客戶姓名',
    contactPhone: '聯繫電話',
    email: '郵箱',
    lineId: 'LINE ID',
    address: '地址',
    repairTypeLabel: '修繕類型',
    supplementDesc: '補充說明',
    sourceChannel: '如何得知',
    recommenderName: '介紹人',
    joinLineGroup: '加入LINE群',
    yes: '是',
    no: '否',
    images: '圖片',
    noImages: '無',
    // 操作
    confirmOrder: '確認接單',
    assignStore: '分配門店',
    cancel: '取消',
    // 修缮类型选项
    waterType: '水類',
    electricType: '電類',
    leakage: '漏水',
    comprehensive: '綜合',
    bathEquipment: '沐浴設備',
    other: '其他',
    // 分配门店
    reservationInfo: '預約信息',
    selectStore: '選擇門店',
    searchStorePlaceholder: '搜索門店名稱/店長名/手機號',
    active: '啟用',
    inactive: '停用',
    businessHours: '營業時間',
    storePhone: '門店電話',
    manager: '店長',
    confirmAssign: '確認分配',
    pleaseSelectStore: '請選擇門店',
    assignStoreSuccess: '門店分配成功',
    assignStoreFailed: '門店分配失敗',
    fetchStoreListFailed: '獲取門店列表失敗'
  },
  administrativeOrders: {
    title: '訂單管理',
    customerName: '客戶姓名',
    customerPhone: '客戶電話',
    caseNo: '案例編號',
    orderStatus: '訂單狀態',
    onlyUrgent: '僅緊急',
    search: '搜索',
    reset: '重置',
    urgent: '緊急',
    urgentTag: '急',
    address: '地址',
    repairType: '修繕類型',
    assignedStore: '分配門店',
    assignStore: '分配門店',
    orderDetail: '訂單詳情',
    close: '關閉',
    // 订单状态
    pending: '待分配',
    quoted: '已報價',
    materialPreparing: '備料中',
    constructing: '施工中',
    acceptance: '驗收中',
    completed: '已完成',
    closed: '已結案',
    cancelled: '已取消',
    // 订单详情阶段
    orderDemandStage: '訂單需求',
    quotationStage: '報價階段',
    materialStage: '備料階段',
    constructionStage: '施工階段',
    acceptanceStage: '驗收階段',
    reviewStage: '評價階段',
    // 订单需求字段
    reservationId: '預約ID',
    realName: '客戶姓名',
    phone: '聯繫電話',
    regionText: '地區',
    supplementDesc: '補充說明',
    customerDemand: '客戶需求',
    customerUploadMedia: '客戶上傳媒體',
    // 报价阶段
    totalAmount: '總金額',
    mainQuotation: '主報價',
    subQuotation: '追加報價',
    quotationType: '報價類型',
    quotedAmount: '報價金額',
    quotedTime: '報價時間',
    workDescription: '工作描述',
    approved: '已批准',
    // 备料阶段
    materialName: '材料名稱',
    materialPrice: '價格',
    prepareTime: '備料時間',
    images: '圖片',
    // 施工阶段
    constructionDate: '施工日期',
    beforeConstruction: '施工前',
    duringConstruction: '施工中',
    afterConstruction: '施工後',
    createTime: '創建時間',
    stageDesc: '階段描述',
    // 验收阶段
    completionDate: '完工日期',
    acceptanceDate: '驗收日期',
    chargeAmount: '收費金額',
    collectionAmount: '收款金額',
    paymentMethod: '付款方式',
    customerConfirm: '客戶確認',
    confirmed: '已確認',
    notConfirmed: '未確認',
    acceptanceImages: '驗收圖片',
    customerSignature: '客戶簽名',
    // 评价阶段
    customerToTechnician: '客戶對師傅的評價',
    technicianToCustomer: '師傅對客戶的評價',
    reviewed: '已評價',
    notReviewed: '未評價',
    rating: '評分',
    reviewContent: '評價內容',
    reviewerName: '評價人',
    reviewTime: '評價時間',
    noReview: '暫無評價',
    technicianAvgRating: '師傅平均評分',
    customerAvgRating: '客戶平均評分',
    reviewCount: '條評價'
  },
  priceTemplate: {
    title: '報價單模板管理',
    categoryManagement: '分類管理',
    templateList: '報價模板列表',
    addCategory: '新增分類',
    editCategory: '編輯分類',
    addTemplate: '新增模板',
    editTemplate: '編輯模板',
    categoryName: '分類名稱',
    repairType: '修繕類型',
    itemName: '項目名稱',
    price: '價格',
    pricePlaceholder: '例如：$800~$1500/個',
    remark: '備註',
    sortOrder: '排序',
    enabled: '啟用',
    disabled: '禁用',
    searchPlaceholder: '搜索項目名稱、備註',
    pleaseEnterCategoryName: '請輸入分類名稱',
    pleaseCompleteForm: '請填寫完整信息',
    deleteCategoryConfirm: '確定要刪除此分類嗎？',
    deleteTemplateConfirm: '確定要刪除此模板嗎？'
  },
  referrer: {
    title: '介紹人統計',
    // 概览
    totalReferrals: '總介紹訂單數',
    totalReferrers: '總介紹人數',
    completedCount: '已完成訂單數',
    totalRevenue: '總收入金額',
    completionRate: '完成率',
    monthReferrals: '本月介紹訂單',
    monthReferrers: '本月介紹人數',
    // 排行榜
    ranking: '介紹人排行榜',
    sortByReferralCount: '按介紹數排序',
    sortByRevenue: '按收入排序',
    sortByCompletedCount: '按完成數排序',
    sortByName: '按姓名排序',
    // 列表
    list: '介紹人列表',
    searchPlaceholder: '搜索介紹人姓名',
    referrerName: '介紹人姓名',
    referralCount: '介紹訂單數',
    revenue: '收入',
    firstReferralDate: '首次介紹日期',
    lastReferralDate: '最近介紹日期',
    // 详情
    detail: '介紹人詳情',
    orderList: '介紹訂單列表',
    caseNo: '案件編號',
    customerName: '客戶姓名',
    phone: '電話',
    address: '地址',
    repairType: '修繕類型',
    status: '狀態',
    chargeAmount: '收費金額',
    createTime: '創建時間',
    fetchDetailFailed: '獲取詳情失敗',
    // 状态
    statusPending: '待分配',
    statusMaterialPreparing: '備料中',
    statusConstructing: '施工中',
    statusAcceptance: '驗收中',
    statusCompleted: '已完成',
    statusClosed: '已結案',
    statusCancelled: '已取消'
  },
  adminManagement: {
    title: '管理員管理',
    add: '新增管理員',
    edit: '編輯管理員',
    detail: '管理員詳情',
    userId: '用戶ID',
    username: '用戶名',
    realName: '真實姓名',
    phone: '手機號',
    email: '郵箱',
    roleType: '角色類型',
    admin: '管理員',
    administrative: '行政',
    enabled: '啟用',
    disabled: '禁用',
    lastLoginTime: '最後登錄',
    currentPassword: '當前密碼',
    newPassword: '新密碼',
    password: '密碼',
    allStatus: '全部狀態',
    // 占位符
    currentPasswordPlaceholder: '請輸入當前管理員密碼',
    usernamePlaceholder: '請輸入用戶名',
    passwordPlaceholder: '請輸入密碼',
    newPasswordPlaceholder: '留空則不修改密碼',
    realNamePlaceholder: '請輸入真實姓名',
    phonePlaceholder: '請輸入手機號',
    emailPlaceholder: '請輸入郵箱',
    roleTypePlaceholder: '請選擇角色類型',
    // 提示
    currentPasswordTip: '為了安全，所有操作都需要驗證當前管理員密碼',
    // 验证
    currentPasswordRequired: '請輸入當前密碼',
    usernameRequired: '請輸入用戶名',
    passwordRequired: '請輸入密碼',
    passwordMinLength: '密碼至少6位',
    realNameRequired: '請輸入真實姓名',
    phoneRequired: '請輸入手機號',
    phoneFormatError: '手機號格式錯誤',
    emailFormatError: '郵箱格式錯誤',
    roleTypeRequired: '請選擇角色類型',
    // 消息
    createSuccess: '創建成功',
    updateSuccess: '更新成功',
    deleteSuccess: '刪除成功',
    deleteConfirm: '確定要刪除管理員 {name} 嗎？',
    cannotDeleteSelf: '不能刪除自己的賬號',
    fetchListFailed: '獲取列表失敗',
    fetchDetailFailed: '獲取詳情失敗'
  },
  errors: {
    // 用户相关错误
    userNotFound: '用戶不存在',
    passwordError: '密碼錯誤',
    userDisabled: '用戶已被禁用',
    userLocked: '用戶已被鎖定',
    // 认证相关错误
    tokenExpired: '登錄已過期，請重新登錄',
    tokenInvalid: '登錄憑證無效',
    loginExpired: '登錄已過期，請重新登錄',
    // 权限相关错误
    permissionDenied: '沒有權限訪問',
    noPermission: '沒有權限訪問',
    // 数据相关错误
    parameterInvalid: '參數錯誤',
    dataNotFound: '數據不存在',
    resourceNotFound: '請求的資源不存在',
    // 操作相关错误
    operationFailed: '操作失敗，請稍後再試',
    requestFailed: '請求失敗',
    // 网络相关错误
    networkError: '網絡錯誤，請檢查網絡連接',
    serverError: '服務器錯誤',
    requestConfigError: '請求配置錯誤'
  }
}
